import { createFileRoute } from "@tanstack/react-router";
import { SubServicePage } from "@/components/SubServicePage";
import { SEO_SITE, hreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const meta = {"th":{"h1":"Destination Thailand Visa (DTV) — วีซ่าดิจิทัลโนแมด 5 ปี","metaTitle":"DTV Visa ไทย 5 ปี — Digital Nomad / Muay Thai / Workation | NYC","metaDesc":"บริการยื่น Destination Thailand Visa (DTV) วีซ่าดิจิทัลโนแมด 5 ปี Multi-entry อยู่ได้ครั้งละ 180 วัน ครอบคลุม Wor — ปรึกษาฟรี ประเมินงานให้ทันที ทักไลน์ได้เลย"},"en":{"h1":"Destination Thailand Visa (DTV) — 5-year Digital Nomad Visa","metaTitle":"Thailand DTV Visa — 5-year Digital Nomad / Workation Visa | NYC","metaDesc":"Destination Thailand Visa (DTV) filing service — 5-year multi-entry, 180 days per stay. Remote work, Muay — Send your documents for a free eligibility check."}} as const;

export const Route = createFileRoute("/en/visa/dtv")({
  head: () => {
    const url = `${SEO_SITE}/en/visa/dtv`;
    const c = meta.en;
    return {
      meta: [
        { title: ctaTitle(c.metaTitle, "/en/visa/dtv", "en")},
        { name: "description", content: ctaDesc(c.metaDesc, "/en/visa/dtv", "en")},
        { property: "og:title", content: ctaTitle(c.metaTitle, "/en/visa/dtv", "en")},
        { property: "og:description", content: ctaDesc(c.metaDesc, "/en/visa/dtv", "en")},
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "en_US" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: url }, ...hreflangLinks("/visa/dtv", "/en/visa/dtv")],
    };
  },
  component: () => <SubServicePage slug="visa/dtv" locale="en" />,
});
